import React, {
  useState,
  useEffect,
  useMemo,
  useRef,
  useCallback,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroller';

import { NotificationActions } from '../../../store/actions/notifications';

import {
  Container,
  Badge,
  NotificationContent,
  NotificationHeader,
  NotificationList,
  NotificationEmptyMessage,
  Notification,
} from './styles';

export default function Notifications() {
  const [visible, setVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const { signedUser } = useSelector((state) => state.users);
  const { notifications } = useSelector((state) => state.notifications.state);

  const notificationsContentRef = useRef(null);
  const buttonRef = useRef(null);

  const dispatch = useDispatch();

  const handleClickOutside = useCallback((event) => {
    if (
      notificationsContentRef.current &&
      !notificationsContentRef.current.contains(event.target) &&
      buttonRef.current &&
      !buttonRef.current.contains(event.target)
    ) {
      setVisible(false);
    }
  }, []);

  useEffect(() => {
    window.addEventListener('click', handleClickOutside);
    window.addEventListener('mouseup', handleClickOutside);

    return () => {
      window.removeEventListener('click', handleClickOutside);
      window.removeEventListener('mouseup', handleClickOutside);
    };
  });

  useEffect(() => {
    if (signedUser && signedUser.selectedCompany) {
      dispatch(
        NotificationActions.list({
          companyId: signedUser.selectedCompany._id,
          page: currentPage,
        })
      );
    }
  }, [signedUser, dispatch, currentPage]);

  useEffect(() => {
    if (notifications.page) {
      setCurrentPage(notifications.page);
    }
  }, [notifications.page]);

  const handleLoadMore = useCallback(() => {
    if (
      currentPage < notifications.totalPages &&
      currentPage === notifications.page
    ) {
      setCurrentPage(currentPage + 1);
    }
  }, [currentPage, notifications.totalPages, notifications.page]);

  const checkIfHasUnread = useMemo(() => {
    return (
      notifications &&
      notifications.data &&
      notifications.data.find((notification) => !notification.read)
    );
  }, [notifications]);

  const handleMarkAsRead = useCallback(
    (id) => {
      dispatch(NotificationActions.updateStatus({ id }));
    },
    [dispatch]
  );

  return (
    <Container>
      <Badge
        hasUnread={checkIfHasUnread}
        onClick={() => setVisible(!visible)}
        visible={visible}
        ref={buttonRef}
      >
        <svg
          width="16px"
          height="16px"
          viewBox="0 0 16 16"
          className="bi bi-bell-fill"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zm.995-14.901a1 1 0 1 0-1.99 0A5.002 5.002 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901z" />
        </svg>
      </Badge>

      <NotificationContent visible={visible} ref={notificationsContentRef}>
        <NotificationHeader>Notificações</NotificationHeader>

        <NotificationList>
          {notifications && notifications.data && notifications.data.length ? (
            <InfiniteScroll
              pageStart={1}
              loadMore={() => handleLoadMore()}
              hasMore={currentPage < notifications.totalPages}
              loader={<div key={0}>Carregando...</div>}
              useWindow={false}
              threshold={10}
            >
              {notifications.data.map((notification) => (
                <Notification
                  key={notification._id}
                  unread={!notification.read}
                >
                  <div className="notification__info">
                    <h5>{notification.content}</h5>
                    <time>{notification.timeDistance}</time>
                  </div>

                  {!notification.read && (
                    <button
                      type="button"
                      className="notification__button"
                      onClick={() => handleMarkAsRead(notification._id)}
                    >
                      Marcar como lida
                    </button>
                  )}
                </Notification>
              ))}
            </InfiniteScroll>
          ) : (
            <NotificationEmptyMessage>
              Não há notificações
            </NotificationEmptyMessage>
          )}
        </NotificationList>
      </NotificationContent>
    </Container>
  );
}
